import $ from 'jquery';

export default class Gdpr {
	constructor() {
		this.gdprBanner = $('.gdpr-banner');
		this.filler = $('.gdpr-banner__filler');
		this.wrapper = $('.gdpr-banner__wrapper');
		this.close = $('.gdpr-banner__close');
		this.mobileTop = $('.header__mobile-top');
		this.mobileNav = $('.header__nav');
	}

	init() {
		$(window).on('load resize', () => {
			if ($(window).width() < 1024 && !this.gdprBanner.hasClass('gdpr-banner_hide')) {
				this.filler.css({
					height: this.wrapper.outerHeight()
				});
			}else {
				this.filler.css({height: ''});
			}
		});

		this.close.on('click', event => {
			event.preventDefault();

			this.gdprBanner.addClass('gdpr-banner_hide');
			setTimeout(() => {
				this.gdprBanner.slideUp();
				this.mobileTop.animate({
					top: 0
				}, 400);
				this.mobileNav.animate({
					top: 68
				}, 400);
			}, 400);
		});
	}
}



// WEBPACK FOOTER //
// ./app/blocks/gdpr-banner/index.js